import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleReportComponent } from './components';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SpinnerAlternativeComponent } from './components/spinner/spinner-alternative.component';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RippleModule } from 'primeng/ripple';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DatePickerModule } from 'primeng/datepicker';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EditorModule } from 'primeng/editor';
import { MessageModule } from 'primeng/message';
import { ReportSecurityComponent } from './components/report-security/report-security.component';
import { EmailReportComponent } from './components/email-report/email-report.component';

import { TabsModule } from 'primeng/tabs';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { DropdownModule } from 'primeng/dropdown';
import { OrderListModule } from 'primeng/orderlist';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { DrawerModule } from 'primeng/drawer';
import { DialogModule } from 'primeng/dialog';
import { GenerateReportFormComponent } from './components/generate-report-form/generate-report-form.component';
import { TimezoneTransformPipe } from './pipes/timezone-transform.pipe';
import { DrilldownReportComponent } from './components/drilldown-report/drilldown-report.component';
import { TableModule } from 'primeng/table';
import { MobileViewComponent } from './components/mobile-view/mobile-view.component';
import { ExportToastComponent } from './components/export-toast/export-toast.component';


@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    SpinnerComponent,
    SpinnerAlternativeComponent,
    ScheduleReportComponent,
    GenerateReportFormComponent,
    ReportSecurityComponent,
    EmailReportComponent,
    TimezoneTransformPipe,
    DrilldownReportComponent,
    MobileViewComponent,
    ExportToastComponent
  ],
  imports: [
    CommonModule,
    BadgeModule, 
    AvatarModule, 
    ButtonModule, 
    ToggleSwitchModule, 
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    DropdownModule,
    OrderListModule, 
    CheckboxModule, 
    InputTextModule, 
    RadioButtonModule, 
    MultiSelectModule, 
    MenuModule, 
    TooltipModule,
    DrawerModule,
    DialogModule,
    ToastModule,
    TabsModule,
    AutoCompleteModule,
    RippleModule,
    ProgressSpinnerModule,
    DatePickerModule,
    AccordionModule,
    ConfirmDialogModule,
    EditorModule,
    MessageModule,
    TableModule
  ],
  exports: [
    SpinnerComponent,
    SpinnerAlternativeComponent,
    ScheduleReportComponent,
    GenerateReportFormComponent,
    ReportSecurityComponent,
    EmailReportComponent,
    CommonModule,
    BadgeModule, 
    AvatarModule, 
    ButtonModule, 
    ToggleSwitchModule, 
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    DropdownModule,
    OrderListModule, 
    CheckboxModule, 
    InputTextModule, 
    RadioButtonModule, 
    MultiSelectModule, 
    MenuModule, 
    TooltipModule,
    DrawerModule,
    ToastModule,
    TabsModule,
    AutoCompleteModule,
    RippleModule,
    ProgressSpinnerModule,
    DatePickerModule,
    AccordionModule,
    ConfirmDialogModule,
    EditorModule,
    MessageModule,
    DrilldownReportComponent,
    MobileViewComponent,
    ExportToastComponent
  ]
})
export class SharedModule { } 